module.exports = __webpack_public_path__ + "static/media/clue03.9b7b27f5.png";